/**
 * Hauteur estimée (mm) d'un texte réglementaire dans un cadre de largeur donnée,
 * lignes APRÈS retour automatique (#336). Le rendu d'export COUPE ce qui dépasse
 * du cadre : compter les seuls « \n » donnait 5 mm à une phrase de 180 caractères.
 *
 * Étalon mesuré le 14/10 sur les zones réelles : Arial 7 pt chasse 1,11 mm par
 * caractère en moyenne ; 1,4 absorbe les fins de ligne perdues aux coupures de
 * mots et n'a sous-estimé aucune zone réelle ; 3,5 mm par ligne. Le tout suit le
 * corps (une mention en 8 pt chasse et monte de 8/7). Trop haut se voit et se
 * réduit ; trop bas s'imprime coupé.
 *
 * La chasse suit aussi la POLICE : Arial Narrow chasse 0,82 fois Arial (0,365 em
 * contre 0,445 em par caractère, mesuré le 24/10 sur les avances des deux polices,
 * sur les textes du catalogue fictif). Les mentions passant en Arial Narrow 5,5 pt
 * (CORPS_MENTIONS_PT), l'étalon d'Arial y aurait compté 22 % de lignes de trop. La
 * marge de l'étalon (1,4 pour 1,11) est gardée telle quelle.
 *
 * Module sans dépendance : importé par le constructeur du bloc ET par la
 * réconciliation (regulatoryTemplate), qui ne s'importent pas l'un l'autre.
 */
const CHASSE_RELATIVE = { 'arial narrow': 0.82 };

/** « "Arial Narrow", sans-serif » → 0,82 ; toute autre police : 1 (l'étalon d'Arial). */
const chasseDe = (police) => CHASSE_RELATIVE[String(police || '').split(',')[0].replace(/["']/g, '').trim().toLowerCase()] ?? 1;

export function hauteurTexteEstimee(texte, largeurMm, taillePt = 7, police = 'Arial') {
    const echelle = (Number(taillePt) > 0 ? Number(taillePt) : 7) / 7;
    const parLigne = Math.max(1, Math.floor((Number(largeurMm) || 60) / (1.4 * echelle * chasseDe(police))));
    const lignes = String(texte || '').split('\n')
        .reduce((n, l) => n + Math.max(1, Math.ceil(l.length / parLigne)), 0);
    return Math.max(5, lignes * 3.5 * echelle);
}
